import request from "@/libs/request";

import { getDashboardSearchSignal } from "@/libs/dashboardSearch";

import { CommonResponse } from "@/types/common";
import {
  GetDashbaordProductRatioResponse,
  GetDashboardBidSummaryResponse,
  GetDashboardMonthlyBidCountResponse,
  GetDashboardProjectSummaryResponse,
  GetDivisionListResponse,
  GetDminsByContractCountResponse,
  GetMonthlyBidNoticeContractAmountStatsResponse,
  GetMonthlyProductRatioStatsResponse,
  GetProjectDetailsResponse,
  GetSmfRatioStatsResponse,
  GetStatsByContractAmountResponse,
  GetStatsByContractCountResponse,
  GetStatsByProductsResponse,
  GetTargetAchievementResponse,
  GetRawContractsResponse,
  GetAgencyBudgetsResponse,
  GetAgencyBudgetsByTypeResponse,
  GetMonthlyThermoRatioResponse,
  GetBuyerTypeMarginsResponse,
  GetTopBuyersByScenarioResponse,
  GetWinnerTopBuyersResponse,
  GetAgencyFilterResponse,
  CreateAgencyFilterResponse,
  DeleteAgencyFilterResponse,
} from "@/types/dashboard";

// 검색 세대에 묶이는 대시보드 조회 호출.
// 새 검색(beginDashboardSearch)이 시작되면 진행 중인 이전 검색의 요청은 취소된다.
const searchPost = <T,>(input: string) =>
  request.post<CommonResponse<T>>(
    `/compute`,
    { input },
    { signal: getDashboardSearchSignal() }
  );

export const GetDivisionList = async () =>
  request.post<CommonResponse<GetDivisionListResponse>>(`/compute`, {
    input: "dashboard.settings.get_divisions()",
  });

export const GetDashboardBidSummary = async (params: string) =>
  searchPost<GetDashboardBidSummaryResponse>(
    `dashboard.get_bid_notice_summary(${params})`
  );
export const GetMonthlyBidCount = async (params: string) =>
  searchPost<GetDashboardMonthlyBidCountResponse>(
    `dashboard.get_monthly_bid_notice_count_stats(${params})`
  );
export const GetProductRatio = async (params: string) =>
  searchPost<GetDashbaordProductRatioResponse>(
    `dashboard.get_product_ratio(${params})`
  );
export const GetStatsByProducts = async (params: string) =>
  searchPost<GetStatsByProductsResponse>(
    `dashboard.get_stats_by_products(${params})`
  );

export const GetMonthlyBidNoticeContractAmountStats = async (params: string) =>
  searchPost<GetMonthlyBidNoticeContractAmountStatsResponse>(
    `dashboard.get_monthly_bid_notice_contract_amount_stats(${params})`
  );
export const GetMonthlyProductRatioStats = async (params: string) =>
  searchPost<GetMonthlyProductRatioStatsResponse>(
    `dashboard.get_monthly_product_ratio_stats(${params})`
  );

export const GetStatsByContractAmount = async (params: string) =>
  searchPost<GetStatsByContractAmountResponse>(
    `dashboard.get_stats_by_contract_amount(${params})`
  );

export const GetDashboardProjectSummary = async (params: string) =>
  searchPost<GetDashboardProjectSummaryResponse>(
    `dashboard.get_project_summary(${params})`
  );

export const GetTargetAchievement = async () =>
  request.post<CommonResponse<GetTargetAchievementResponse>>(`/compute`, {
    input: `dashboard.settings.get_target_achievement()`,
  });

export const SetExchangeRate = async (params: number) =>
  request.post(`/compute`, {
    input: `dashboard.settings.set_exchange_rate(exchange_rate=${params})`,
  });

export const GetSmfRatioStats = async (params: string) =>
  searchPost<GetSmfRatioStatsResponse>(
    `dashboard.get_smf_ratio_stats(${params})`
  );

export const GetStatsByContractCount = async (params: string) =>
  searchPost<GetStatsByContractCountResponse>(
    `dashboard.get_stats_by_contract_count(${params})`
  );

export const GetDminsByContractCount = async (params: string) =>
  searchPost<GetDminsByContractCountResponse>(
    `dashboard.get_dmins_by_contract_count(${params})`
  );

export const SetTargetArchievement = async (params: string) =>
  request.post(`/compute`, {
    input: `dashboard.settings.set_target_achievement(${params})`,
  });

export const GetProjectDetails = async (params: string) =>
  searchPost<GetProjectDetailsResponse>(
    `dashboard.get_project_details(${params})`
  );

// 입찰공고 탭 계약 목록
export const GetRawContracts = async (params: string) =>
  searchPost<GetRawContractsResponse>(`dashboard.get_raw_contracts(${params})`);

// 수요기관별 집행예산
export const GetAgencyBudgets = async (params: string) =>
  searchPost<GetAgencyBudgetsResponse>(
    `dashboard.get_agency_budgets(${params})`
  );

// 수요기관별 소모품 및 장비 비율
export const GetAgencyBudgetsByType = async (params: string) =>
  searchPost<GetAgencyBudgetsByTypeResponse>(
    `dashboard.get_agency_budgets_by_type(${params})`
  );

// 월별 SMF/TPP 비중
export const GetMonthlyThermoRatio = async (params: string) =>
  searchPost<GetMonthlyThermoRatioResponse>(
    `dashboard.get_monthly_thermo_ratio(${params})`
  );

// 디비전별 마진 금액
export const GetBuyerTypeMargins = async (params: string) =>
  searchPost<GetBuyerTypeMarginsResponse>(
    `dashboard.get_buyer_type_margins(${params})`
  );

// 구매업체별 Top 5 매입가 합계 & 비중
export const GetTopBuyersByScenario = async (params: string) =>
  searchPost<GetTopBuyersByScenarioResponse>(
    `dashboard.get_top_buyers_by_scenario(${params})`
  );

// 낙찰된 업체의 구매업체 비율
export const GetWinnerTopBuyers = async (params: string) =>
  searchPost<GetWinnerTopBuyersResponse>(
    `dashboard.get_winner_top_buyers(${params})`
  );

// 수요기관 필터 읽기
export const GetAgencyFilter = async () =>
  request.post<CommonResponse<GetAgencyFilterResponse>>(`/compute`, {
    input: `dashboard.settings.agency_filter_read()`,
  });

// 수요기관 필터 쓰기
export const CreateAgencyFilter = async (clientId: string) =>
  request.post<CommonResponse<CreateAgencyFilterResponse>>(`/compute`, {
    input: `dashboard.settings.agency_filter_create(client_id="${clientId}")`,
  });

// 수요기관 필터 삭제
export const DeleteAgencyFilter = async (clientId: string) =>
  request.post<CommonResponse<DeleteAgencyFilterResponse>>(`/compute`, {
    input: `dashboard.settings.agency_filter_delete(client_id="${clientId}")`,
  });
